/**
 * Favoritos (wishlist) - PadelHouse (tema Horizon).
 *
 * Sistema propio sin app ni login: persiste en localStorage (`ph_wishlist_v1`).
 * Guarda datos minimos de cada producto (handle, titulo, url, imagen, precio,
 * marca) para poder pintar la pagina /pages/favoritos sin llamadas extra.
 *
 * - Botones [data-ph-wish] en fichas/tarjetas: alternan guardado y estado.
 * - Pagina de favoritos: [data-ph-wishlist-list] se rellena desde localStorage
 *   con la tarjeta estilo "Palas destacadas" (tile gris, pill de marca, titulo
 *   bold) + acciones por tarjeta: Comparar (via PHComparar) y Quitar.
 * - [data-ph-fav-capture]: bloque "recibe tu lista por email" (via PHCapture,
 *   tag ph-lista-favoritos). Visible solo con favoritos guardados.
 * - API publica window.PHWishlist para el buscador y otras piezas.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ph_wishlist_v1';

  /**
   * Los favoritos guardados ANTES de julio de 2026 llevan la imagen como URL
   * absoluta, con el host congelado del momento en que se guardaron (una vista
   * previa del tema, otro dominio...). Ese host ya no sirve la foto y la tarjeta
   * sale en blanco. El snippet ya guarda ruta relativa, pero eso no arregla lo
   * que un visitante tenga desde antes en su navegador.
   *
   * Se normaliza AL LEER, no al escribir: asi se cura cualquier lista vieja sin
   * pedirle nada al usuario. Se queda con todo a partir de `/cdn/`, que es la
   * parte que sirve igual desde cualquier dominio de la tienda.
   */
  function rutaRelativa(url) {
    if (typeof url !== 'string' || url.indexOf('http') !== 0) return url;
    var corte = url.indexOf('/cdn/');
    return corte === -1 ? url : url.slice(corte);
  }

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      var migrado = false;
      for (var i = 0; i < parsed.length; i++) {
        if (!parsed[i] || typeof parsed[i] !== 'object') continue;
        var arreglada = rutaRelativa(parsed[i].image);
        if (arreglada !== parsed[i].image) {
          parsed[i].image = arreglada;
          migrado = true;
        }
      }
      /* Se reescribe una sola vez para no repetir el arreglo en cada lectura. */
      if (migrado) writeAll(parsed);
      return parsed;
    } catch (error) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* almacenamiento no disponible: no rompemos la pagina */
    }
  }

  function has(handle) {
    return readAll().some(function (item) {
      return item.handle === handle;
    });
  }

  function toggle(entry) {
    var items = readAll();
    var index = items.findIndex(function (item) {
      return item.handle === entry.handle;
    });
    var added;
    if (index === -1) {
      items.push(entry);
      added = true;
    } else {
      items.splice(index, 1);
      added = false;
    }
    writeAll(items);
    document.dispatchEvent(new CustomEvent('ph:wishlist:change', { detail: { items: items } }));
    return added;
  }

  function entryFromButton(button) {
    return {
      handle: button.dataset.handle || '',
      title: button.dataset.title || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price: button.dataset.price || '',
      vendor: button.dataset.vendor || ''
    };
  }

  function paintButton(button, saved) {
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.classList.toggle('ph-wish--active', saved);
    var label = button.querySelector('[data-ph-wish-label]');
    if (label) {
      label.textContent = saved ? 'Guardado en favoritos' : 'Guardar en favoritos';
    }
  }

  function initButtons(root) {
    var buttons = (root || document).querySelectorAll('[data-ph-wish]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.dataset.phWishReady === 'true') return;
      button.dataset.phWishReady = 'true';
      paintButton(button, has(button.dataset.handle || ''));
      button.addEventListener('click', function () {
        var added = toggle(entryFromButton(button));
        paintButton(button, added);
      });
    });
  }

  /* Pagina de favoritos ---------------------------------------------------- */

  function pintaComparar(btn, activo) {
    btn.classList.toggle('ph-fav-card__compare--on', activo);
    btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
    btn.textContent = activo ? 'En el comparador' : 'Comparar';
  }

  function renderList() {
    var list = document.querySelector('[data-ph-wishlist-list]');
    if (!list) return;
    var empty = document.querySelector('[data-ph-wishlist-empty]');
    var countEl = document.querySelector('[data-ph-wishlist-count]');
    var capture = document.querySelector('[data-ph-fav-capture]');
    var items = readAll();

    if (countEl) {
      countEl.textContent = items.length === 0
        ? ''
        : items.length === 1 ? '1 pala guardada' : items.length + ' palas guardadas';
    }
    if (capture) capture.hidden = items.length === 0;

    list.textContent = '';

    if (items.length === 0) {
      if (empty) empty.hidden = false;
      list.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    list.hidden = false;

    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'ph-fav-card';

      var link = document.createElement('a');
      link.className = 'ph-fav-card__link';
      link.href = item.url || '#';

      var media = document.createElement('span');
      media.className = 'ph-fav-card__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      link.appendChild(media);

      if (item.vendor) {
        var vendor = document.createElement('span');
        vendor.className = 'ph-fav-card__vendor';
        vendor.textContent = item.vendor;
        link.appendChild(vendor);
      }

      var title = document.createElement('span');
      title.className = 'ph-fav-card__title';
      title.textContent = item.title || '';
      link.appendChild(title);

      if (item.price) {
        var price = document.createElement('span');
        price.className = 'ph-fav-card__price';
        price.textContent = item.price;
        link.appendChild(price);
      }

      li.appendChild(link);

      var acts = document.createElement('div');
      acts.className = 'ph-fav-card__acts';

      if (window.PHComparar) {
        var comp = document.createElement('button');
        comp.type = 'button';
        comp.className = 'ph-fav-card__compare';
        comp.setAttribute('data-ph-fav-compare', item.handle);
        pintaComparar(comp, window.PHComparar.has(item.handle));
        comp.addEventListener('click', function () {
          var r = window.PHComparar.toggle(item);
          if (r.full) {
            window.PHComparar.avisa('Solo puedes comparar 3 palas. Quita una para añadir otra.');
            return;
          }
          pintaComparar(comp, r.added);
        });
        acts.appendChild(comp);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ph-fav-card__remove';
      remove.setAttribute('aria-label', 'Quitar ' + (item.title || 'producto') + ' de favoritos');
      remove.innerHTML =
        '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
        '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
      remove.addEventListener('click', function () {
        toggle({ handle: item.handle });
        initButtons(document);
      });
      acts.appendChild(remove);

      li.appendChild(acts);
      list.appendChild(li);
    });
  }

  /* "Recibe tu lista por email" (PHCapture, tag ph-lista-favoritos) --------- */

  function initCapture() {
    var box = document.querySelector('[data-ph-fav-capture]');
    if (!box || box.dataset.phReady === 'true') return;
    box.dataset.phReady = 'true';

    var send = box.querySelector('[data-ph-fav-send]');
    var msg = box.querySelector('[data-ph-fav-msg]');
    var aviso = function (t, err) {
      msg.textContent = t;
      msg.classList.toggle('is-error', !!err);
      msg.hidden = false;
    };

    send.addEventListener('click', function () {
      if (!window.PHCapture) return aviso('No se pudo enviar. Recarga la página.', true);
      var items = readAll();
      var cuerpo = 'LISTA DE FAVORITOS (' + items.length + ')\n' + items.map(function (i) {
        return '- ' + i.title + ' (' + i.price + ') ' + location.origin + i.url;
      }).join('\n');

      aviso('Enviando…');
      window.PHCapture.enviar({
        email: box.querySelector('[data-ph-fav-email]').value,
        consent: box.querySelector('[data-ph-fav-consent]').checked,
        tipo: 'lista-favoritos',
        cuerpo: cuerpo
      }).then(function () {
        aviso('Lista enviada. Revisa tu correo.');
        send.disabled = true;
      }).catch(function (e) {
        if (e && e.message === 'email') return aviso('Escribe un email válido.', true);
        if (e && e.message === 'consent') return aviso('Marca la casilla para poder enviártela.', true);
        aviso('No se pudo enviar. Inténtalo en un momento.', true);
      });
    });
  }

  function init() {
    initButtons(document);
    renderList();
    initCapture();
  }

  document.addEventListener('ph:wishlist:change', function () {
    renderList();
  });

  /* Si cambia el comparador (desde la barra u otra pagina), refresca el estado
     de los botones "Comparar" de las tarjetas de favoritos. */
  document.addEventListener('ph:comparar:change', function () {
    if (!window.PHComparar) return;
    var btns = document.querySelectorAll('[data-ph-fav-compare]');
    Array.prototype.forEach.call(btns, function (b) {
      pintaComparar(b, window.PHComparar.has(b.getAttribute('data-ph-fav-compare')));
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-inicializa tras navegaciones/reemplazos de seccion del tema Horizon */
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  /* API publica para otras piezas (buscador). */
  window.PHWishlist = {
    has: has,
    items: readAll,
    toggle: toggle
  };
})();
